export default "__VITE_ASSET__BhMC024f__"